import { render, staticRenderFns } from "./ItemListN.vue?vue&type=template&id=c61f4aaa&"
import script from "./ItemListN.vue?vue&type=script&lang=js&"
export * from "./ItemListN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c61f4aaa')) {
      api.createRecord('c61f4aaa', component.options)
    } else {
      api.reload('c61f4aaa', component.options)
    }
    module.hot.accept("./ItemListN.vue?vue&type=template&id=c61f4aaa&", function () {
      api.rerender('c61f4aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/itemListComp/ItemListN.vue"
export default component.exports